export default {
  'product-recommendations:title': 'Schon probiert?',
};
